export type AppBootstrapMode = 'full-app' | 'rpa-auxiliary-window' | 'minimal';

export type BootstrapModeComponent = {
  bootstrapMode?: AppBootstrapMode;
  useMinimalProviders?: boolean;
};

export function resolveAppBootstrapMode(
  component: BootstrapModeComponent
): AppBootstrapMode {
  if (component.bootstrapMode) return component.bootstrapMode;
  return component.useMinimalProviders ? 'minimal' : 'full-app';
}

export function usesMinimalProviderTree(mode: AppBootstrapMode): boolean {
  return mode === 'minimal' || mode === 'rpa-auxiliary-window';
}
